<template>
  <TreeInput
    :label="label"
    :hide-label="hideLabel"
    v-model="value"
    :options="options"
    :placeholder="placeholder"
    :disabled="disabled"
    :error="error"
    :item-key="optionValue || idKey"
    :label-key="optionLabel"
    :model-type="optionValue ? 'id' : 'object'"
    :is-multi="true"
    :transform-to-tree="transformToTree"
    :disable-branch-nodes="disableBranchNodes"
    @change="onChange"
    :invalid="invalid"
    :show-tree-select-options="true"
  />
</template>

<script>
import TreeInput from "@/components/inputs/TreeInput.vue";

export default {
  name: "MultiListInput",
  components: {TreeInput},
  props: {
    modelValue: Array,
    label: {
      type: String,
      required: true
    },
    optionLabel: {
      type: String,
      default: null
    },
    optionValue: {
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    error: {
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    idKey: {
      type: String,
      default: 'value'
    },
    disableBranchNodes: {
      type: Boolean,
      default: false
    },
    transformToTree: {
      type: Boolean,
      default: true
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    }
  }
}
</script>

<style scoped>

</style>
